import React,{useEffect,useState} from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import axios from 'axios';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MuiPhoneNumber from 'material-ui-phone-number';
import { Box, makeStyles, Tab, Tabs } from '@material-ui/core';
import {
  loginUser,
  loginUserOTP,
  loginUserOTPReceived,
  signup,
  forgetPassword,
  verifyOptCode,
  resendOptCode,
  getCartItems,
  addToCart
} from '../../../store/actions/user/User';
import { storage } from '../../../utils/storage'
import { Typography } from '@material-ui/core';
// import * as firebase from 'firebase';
import BackDrop from '../Preloader/BackDrop';
import firebaseApp from '../../../constants/firebase'
import logoIcon from './l.png'


const useStyles = makeStyles((theme) => ({
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  horizontalTabs: {
    padding: '0px'
  },
  indicator: {
    backgroundColor: 'black',
    color: 'black'
  },
  tabItem: {
    '&:focus': {
      outline: '0px'
    }
  },
  tabSelected: {
    outline: 'none !important',
  },
  horiButton: {
    alignItems: 'center !important'
  }
}));

function SignDialog(props) {
  // const { auth } = props;
  const [state, setState] = React.useState({
    emailId: '',
    password: '',
    device: {
      deviceId: '',
      deviceType: '',
      deviceToken: 0
    }
  });

  const [countryCode,setCountryCode]=useState('au');
  const classes = useStyles();

  const [signupState, setSignup] = React.useState({
    lastName: '',
    firstName: '',
    userName: '',
    emailId: '',
    authPassword: '',
    DOB: '2021/12/12',
    address: {
      building_number: 'none',
      street: 'none',
      city: 'none',
      state: 'none',
      country: 'none',
      pincode: 'none'
    }
  });

  const [loginOTP, setLoginOTP] = React.useState(0)
  const [otpSent, setOtpSent] = React.useState(false)
  const [otpError, setOtpError] = React.useState('')

  const [activeTab, setActiveTab] = React.useState(0)
  const [phoneNumber, setPhoneNumber] = React.useState()


  // const [forgotState, setForgot] = React.useState('');
  const [forgetState, setForget] = React.useState({
    userName: ''
  });

  const [messageFromServer, setMessageFromServer] = React.useState('');

  const [codeState, setCode] = React.useState({
    OTP: 0,
    emailId: '',
    device: {
      deviceId: '',
      deviceType: '',
      deviceToken: 0
    }
  });

  const [resendCodeState, setResendCode] = React.useState({ emailId: 0 });
  const [verState, setVer] = React.useState({ isVerified: false });
  const [verificationMessage, setVerificationMessage] = React.useState('');
  const [signState, setForm] = React.useState({
    changeForm: false,
    isVerified: false
  });
  const [forgotPasswordState, setFormForgot] = React.useState({
    changeForm2: false,
    isVerified: false
  });

  const fetchData = async () => {
    
        let response = await axios.get(`https://api.ipdata.co/?api-key=2149942249e807260b34e1d274c9f199d9d49276a3589ae9de828b35`)
        if (response && response.data&&response.data.country_code) {
           setCountryCode(response.data.country_code.toLowerCase())
        }
    
}

useEffect(()=>{
  fetchData()
},[])
  
  const handleCodeChange = (event) => {
    setCode({ ...codeState, [event.target.name]: event.target.value });

    isMobileOTP();
  };
  const handleResendCode = (e) => {
    setResendCode({
      emailId: e.target.value
    });
  };
  const resendCode = (e) => {
    if (resendCodeState.emailId !== 0) {
      props.resendOptCode(resendCodeState);
      setVer({ isVerified: !verState.isVerified });
    } else {
      setVerificationMessage('Please enter your email!');
    }
    props.onClose();
  };

  const checkCode = (e) => {
    if (codeState.OTP !== 0) {
      props.verifyOptCode(codeState);
      setVer({ isVerified: !verState.isVerified });
    } else {
      setVerificationMessage(
        'Please enter your email and the code we sent to you'
      );
    }
    props.onClose();
  };

  const handleClose = () => {
    props.onClose();
  };

  const isMobile = () => {
    if (/Android|webOS|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      const min = 301;
      const max = 800;
      const rand = min + Math.random() * (max - min);
      setState((prevState) => {
        return {
          ...prevState,
          device: {
            deviceToken: '"' + rand + '"',
            deviceId: 'z' + rand + 'xxx',
            deviceType: '2'
          }
        };
      });
    } else if (/iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
      const min = 301;
      const max = 800;
      const rand = min + Math.random() * (max - min);
      setState((prevState) => {
        return {
          ...prevState,
          device: {
            deviceToken: '"' + rand + '"',
            deviceId: 'z' + rand + 'xxx',
            deviceType: '1'
          }
        };
      });
    } else {
      const min = 1;
      const max = 20;
      const rand = min + Math.random() * (max - min);
      setState((prevState) => {
        return {
          ...prevState,
          device: {
            deviceToken: '"' + rand + 200 + '"',
            deviceId: '"' + rand + '"',
            deviceType: '3'
          }
        };
      });
    }
  };
  const isMobileOTP = () => {
    if (/Android|webOS|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      const min = 301;
      const max = 800;
      const rand = min + Math.random() * (max - min);
      setCode((prevState) => {
        return {
          ...prevState,
          device: {
            deviceToken: '"' + rand + '"',
            deviceId: 'z' + rand + 'xxx',
            deviceType: '2'
          }
        };
      });
    } else if (/iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
      const min = 301;
      const max = 800;
      const rand = min + Math.random() * (max - min);
      setCode((prevState) => {
        return {
          ...prevState,
          device: {
            deviceToken: '"' + rand + '"',
            deviceId: 'z' + rand + 'xxx',
            deviceType: '1'
          }
        };
      });
    } else {
      const min = 1;
      const max = 20;
      const rand = min + Math.random() * (max - min);
      setCode((prevState) => {
        return {
          ...prevState,
          device: {
            deviceToken: '"' + rand + 200 + '"',
            deviceId: '"' + rand + '"',
            deviceType: '3'
          }
        };
      });
    }
  };

  const handlePhoneChange = (value) => {
    setPhoneNumber(value)
    const phoneValues = value.split(' ')
    var phone_number = ''
    if (phoneValues && phoneValues.length > 1) {
      for (var i = 1; i < phoneValues.length; i++) {
        phone_number += phoneValues[i]
      }
    }
    setState({ ...state, 'phone_number': phone_number, 'country_code': (phoneValues && phoneValues.length > 0 ? phoneValues[0] : '') });
    isMobile();
  }

  const handleSignInOTPChange = (event) => {
    setLoginOTP(event.target.value)
    setOtpError('')
    setState({ ...state, 'OTP': event.target.value });
    isMobile();
  }

  const handleSignInChange = (event) => {

    setState({ ...state, [event.target.name]: event.target.value });

    isMobile();
  };

  const handleForgetPasswordChange = (event) => {
    setForget({ ...forgetState, [event.target.name]: event.target.value });
  };

  const handleSignUpChange = (event) => {
    setSignup({ ...signupState, [event.target.name]: event.target.value });
  };
  const handleSignInSubmit = (event) => {
    event.preventDefault();
    props.loginUser(state).then((data) => {
      if (data) {
        const carts = storage.getItem('my_carts')
        if (carts) {
          var cartsObj = JSON.parse(carts)
          cartsObj.map((cart) => {
            delete cart.products
          })
          props.addToCart(cartsObj).then((data) => {
            props.getCartItems();
          })
          storage.setItem('my_carts', [])
        } else {
          props.getCartItems();

        }
      }
    });
    // if (auth) window.location.href='/';
    props.onClose();
  };

  const phonenumberValid = (inputtxt) => {
    var phoneno = /^[\s()+-]*([0-9][\s()+-]*){6,20}$/;
    if (inputtxt && inputtxt.match(phoneno)) {
      return true;
    }
    else {
      return false;
    }
  }

  const handleOTPSignInSubmit = (event) => {
    event.preventDefault();
    props.loginUserOTP(state).then((data) => {
      setOtpSent(true)
    });
    // if (auth) window.location.href='/';
  };

  const handleOTPReceivedSignInSubmit = (event) => {
    event.preventDefault();
    props.loginUserOTPReceived(state).then((data) => {
      if (data) {
        const carts = storage.getItem('my_carts')
        if (carts) {
          var cartsObj = JSON.parse(carts)
          cartsObj.map((cart) => {
            delete cart.products
          })
          props.addToCart(cartsObj).then((data) => {
            props.getCartItems();
          })
          storage.setItem('my_carts', [])
        } else {
          props.getCartItems();

        }
        setOtpSent(false)
        const messaging = firebaseApp.messaging()
        messaging.requestPermission()
          .then(async function () {
            const token = await messaging.getToken();
            axios.post(`/api_v_1/user/save-firebase-token`, {
              firebaseToken: token,
            })
              .then(function (response) {
              }).catch((e) => {
                console.log(e)
              })
          })
          .catch(function (err) {
            console.log("Unable to get permission to notify.", err);
          });
        

        props.onClose();
      }
    }).catch((e) => {
      if (e && e.response && e.response.status === 401) {
        setOtpError('Invalid OTP')
      } else {
        setOtpSent(false)
        props.onClose();
      }
    });

  }

  // const handleForgotPasswordSubmit = (event) => {
  //   event.preventDefault();
  //   props.forgetPassword(state);
  //   props.onClose();
  //   if (auth) return <Redirect to="/" />;
  // };

  const handleSignUpSubmit = async (event) => {
    event.preventDefault();

    await props.signup(signupState);
    // if(!props.error_message) setTimeout(async ()=> {
    //   // console.log('trying to login with',signupState.email,signupState.password)
    //   await props.login({
    //     email:signupState.email,
    //     password:signupState.password
    //   });
    // },1300)
    // await props.login({
    //   email:signupState.email,
    //   password:signupState.password
    // });
    // if(props.error_message) {
    //   props.onClose()
    // }
    // else{
    //   props.onClose();
    //   alert('Your account has been registered');
    // }
    props.onClose();
  };

  const handleSignUp = () => {
    setForm({ changeForm: true });
    setFormForgot({ changeForm2: false });
  };

  const handleForgotPassword = () => {
    setFormForgot({ changeForm2: true });
    setForm({ changeForm: false });
  };

  const handleSignIn = () => {
    setForm({ changeForm: false });
    setFormForgot({ changeForm2: false });
  };

  const sendMail = async (e) => {
    e.preventDefault();
    await props.signup(signupState);
    props.onClose();
  };

  const handleForgetPasswordSubmit = (event) => {
    event.preventDefault();
    axios
      .post(
        '/api_v_1/user/forgetpassword',
        forgetState
      )
      .then((response) => {
        setMessageFromServer(
          'Please, check your inbox and insert the code you received and your email to the form bellow.'
        );
        props.history.push('/resetPassword');
        setTimeout(() => {
          setMessageFromServer(' ');
          props.onClose();
        }, 7000);
      })
      .catch((error) => {
        alert(error.message);
        console.error('There was an error!', error);
      });
  };

  // const sendResetPasswordMail = (e) => {
  //   e.preventDefault();
  //   firebase
  //     .auth()
  //     .sendPasswordResetEmail(forgotState)
  //     .then(function (user) {
  //       alert(
  //         "We sent a password reset link to your email address. Click the link within 1 week or you'll need to request a new one. If you don't see the email, check your spam folder."
  //       );
  //     })
  //     .catch(function (e) {
  //       alert(e);
  //       console.log(e);
  //     });
  // };

  // const sendFeedback = (templateId, variables) => {
  //   window.emailjs
  //     .send('sakshams1501@gmail.com', templateId, variables)
  //     .then((res) => {
  //       console.log('Email sent');
  //       setVerificationMessage('Thanks, the email is sent with success');
  //     })
  //     // Handle errors here however you like, or use a React error boundary
  //     .catch((err) =>
  //       setVerificationMessage(
  //         'Oh well, you failed. Here some thoughts on the error that occured:' +
  //           err
  //       )
  //     );
  // };
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };


  const { alert, success_message, error_message } = props.user;
  return (
    <div>
      <BackDrop open={props.common_loader}></BackDrop>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        fullWidth
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <div>
            <img
              src={logoIcon}
              alt="Grospick"
              style={{
                width: '45%',
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
              className="img-fluid"
            />
          </div>
        </DialogTitle>
        {!signState.changeForm && !forgotPasswordState.changeForm2 ? (
          <DialogContent>
            <p
              style={{
                color: 'red',
                fontSize: '16px',
                paddingLeft: '20px',
                paddingRight: '20px'
              }}
            >
              {error_message.error !== undefined ? error_message.error : ''}
            </p>
            <div style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column'
            }}>
              {!otpSent &&
                <Tabs
                  classes={{
                    indicator: classes.indicator,
                    centered: true,
                  }}
                  textColor="inherit"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="Vertical tabs example"
                  value={activeTab}
                  onChange={handleChange}
                >
                  <Tab
                    classes={{
                      wrapper: classes.horiButton,
                      selected: classes.tabSelected
                    }}
                    com
                    label={'Phone Number'}
                    {...HorizonatalA11yProps(0)}
                  />
                  {/* <Tab
                    classes={{
                      wrapper: classes.horiButton,
                      selected: classes.tabSelected
                    }}
                    com
                    label={'Email'}
                    {...HorizonatalA11yProps(0)}
                  /> */}

                </Tabs>
              }
            </div>
            {!otpSent && activeTab == 1 &&
              <form
                style={{
                  paddingLeft: '20px',
                  paddingTop: '1px',
                  paddingRight: '20px',
                  paddingBottom: '50px',
                  margin: 'auto'
                }}
                onSubmit={handleSignInSubmit}
              >
                <TextField
                  id="emailId"
                  label="Email"
                  type="email"
                  name="emailId"
                  fullWidth
                  onChange={handleSignInChange}
                  required
                />
                <br></br>
                <br></br>
                <TextField
                  id="password"
                  label="Password"
                  type="password"
                  name="password"
                  fullWidth
                  onChange={handleSignInChange}
                  required
                />
                <br></br>
                <br></br>
                <Typography align="center">
                  <Button
                    className="btnAdd"
                    style={{
                      width: '90px', textDecoration: 'none', color: 'white',
                      background: 'rgb(1, 160, 90)'
                    }}
                    type="submit"
                  >
                    Sign In
                  </Button>
                </Typography>
              </form>
            }
            {!otpSent && activeTab == 0 && <form
              style={{
                paddingLeft: '20px',
                paddingTop: '1px',
                paddingRight: '20px',
                paddingBottom: '50px',
                margin: 'auto'
              }}
              onSubmit={handleOTPSignInSubmit}
            >
              <div style={{ marginTop: '10%', marginLeft: '10%' }}>
                <MuiPhoneNumber disableDropdown={true} defaultCountry={countryCode} onChange={handlePhoneChange} />
                <Button
                  className="btnAdd"
                  style={{
                    width: '128px', textDecoration: 'none',
                    marginLeft: '12%',
                    color: 'white',
                    background: (!phonenumberValid(phoneNumber) ? 'grey' : 'rgb(1, 160, 90)')
                  }}
                  type="submit"
                  disabled={!phonenumberValid(phoneNumber)}
                >
                  Send OTP
                </Button>
              </div>
            </form>}
            {otpSent && <form
              style={{
                paddingLeft: '20px',
                paddingTop: '1px',
                paddingRight: '20px',
                paddingBottom: '50px',
                margin: 'auto'
              }}
              onSubmit={handleOTPReceivedSignInSubmit}
            >
              <div style={{ marginTop: '10%', marginLeft: '10%' }}>
                <TextField
                  id="otp"
                  label="OTP"
                  type="number"
                  name="OTP"
                  onChange={handleSignInOTPChange}
                  required
                />
                <Button
                  className="btnAdd"
                  style={{
                    width: '128px', textDecoration: 'none',
                    marginLeft: '12%',
                    color: 'white',
                    background: (!loginOTP || loginOTP.length != 6 ? 'grey' : 'rgb(1, 160, 90)')
                  }}
                  type="submit"
                  disabled={!loginOTP || loginOTP.length != 6}
                >
                  Submit
                </Button>

                {otpError ? <div style={{ color: 'red', fontSize: '14px' }}>{otpError}</div> : ''}
              </div>
              <div style={{ display: 'flex', marginTop: '4%' }}>
                <Button
                  className="btnAdd"
                  style={{
                    width: '57px',
                    height: '32px',
                    alignItems: 'flex-end',
                    display: 'flex',
                    marginLeft: '93%',
                    fontSize: '11px',
                    textDecoration: 'none',
                    marginLeft: '10%',
                    color: 'white',
                    background: ('rgb(1, 160, 90)')
                  }}
                  type="submit"
                  onClick={() => {
                    setOtpSent(false)
                    setPhoneNumber(null)
                  }}
                >
                  Back
                </Button>
              </div>
            </form>}
            {activeTab !== 0 &&
              <>
                <Typography
                  align="center"
                  style={{ paddingBottom: '10px', marginBottom: '10px' }}
                >
                  <Link
                    onClick={handleForgotPassword}
                    style={{
                      paddingBottom: '20px',
                      textDecoration: 'none',
                      color: '#34918c99',
                      marginBottom: '10px'
                    }}
                  >
                    Forgot your password?
                  </Link>
                </Typography>
                <Typography align="center">
                  Don't have an account?
                  <Link
                    onClick={handleSignUp}
                    style={{
                      textDecoration: 'none',
                      color: '#34918c99',
                      paddingLeft: '6px'
                    }}
                  >
                    Signup
                  </Link>
                </Typography>
              </>
            }
          </DialogContent>
        ) : !forgotPasswordState.changeForm2 && signState.changeForm ? (
          <DialogContent>
            <p
              style={{
                color: 'red',
                fontSize: '16px',
                paddingLeft: '20px',
                paddingRight: '20px'
              }}
            >
              {success_message.general !== undefined
                ? success_message.general
                : ''}
              {error_message.error !== undefined ? error_message.error : ''}
            </p>
            <form
              style={{ padding: '40px', paddingTop: '5px', margin: 'auto' }}
              onSubmit={handleSignUpSubmit}
            >
              <TextField
                id="firstName"
                label="Firstname"
                name="firstName"
                fullWidth
                onChange={handleSignUpChange}
                required
              />
              <br />
              <TextField
                id="lastName"
                label="Lastname"
                name="lastName"
                fullWidth
                onChange={handleSignUpChange}
                required
              />
              <br />
              <TextField
                id="userName"
                label="Username"
                name="userName"
                fullWidth
                onChange={handleSignUpChange}
                required
              />
              <br></br>
              <br></br>
              <TextField
                id="emailId"
                type="email"
                label="Email"
                name="emailId"
                fullWidth
                onChange={handleSignUpChange}
                required
              />
              <br></br>
              <br></br>
              <TextField
                id="authPassword"
                label="Password"
                type="password"
                name="authPassword"
                fullWidth
                onChange={handleSignUpChange}
                required
              />
              <br></br>
              <br></br>
              <Typography align="center">
                {!verState.isVerified ? (
                  <>
                    <Button className="btnAdd" onClick={sendMail} style={{
                      color: 'white',
                      background: 'rgb(1, 160, 90)'
                    }}>
                      Signup{' '}
                    </Button>
                    <br />
                    <br /> <br />
                    <p
                      style={{
                        color: '#34918c',
                        paddingLeft: 0,
                        paddingRight: 0
                      }}
                    >
                      *Once you sign up, we will send you an email which
                      contains a Verification Code to verify the account
                      ownership
                    </p>
                    <h6
                      style={{
                        paddingLeft: '20px',
                        paddingTop: '10px',
                        paddingRight: '20px',
                        paddingBottom: '5px',
                        color: 'red'
                      }}
                    >
                      {verificationMessage}
                    </h6>
                    <TextField
                      id="emailId"
                      label="Enter your email"
                      name="emailId"
                      fullWidth
                      onChange={handleCodeChange}
                      required
                    />
                    <TextField
                      id="OTP"
                      label="Enter verification code"
                      name="OTP"
                      fullWidth
                      onChange={handleCodeChange}
                      required
                    />
                    <Button
                      className="btnAdd"
                      style={{
                        marginTop: '15px', color: 'white',
                        background: 'rgb(1, 160, 90)'
                      }}
                      onClick={checkCode}
                    >
                      Verify account
                    </Button>
                    <br />
                    <br />
                    <p
                      style={{
                        color: '#34918c',
                        paddingLeft: 0,
                        paddingRight: 0
                      }}
                    >
                      *You did not receive the Verification Code? Please enter
                      your email and press the Resend button!
                    </p>
                    <TextField
                      id="emailId"
                      label="Enter your email"
                      name="emailId"
                      fullWidth
                      onChange={handleResendCode}
                      required
                    />
                    <Button
                      className="btnAdd"
                      style={{
                        marginTop: '15px', color: 'white',
                        background: 'rgb(1, 160, 90)'
                      }}
                      onClick={resendCode}
                    >
                      Resend
                    </Button>
                  </>
                ) : (
                  <Button
                    className="btnAdd"
                    style={{ width: '90px', textDecoration: 'none' }}
                    type="submit"
                  >
                    Signup
                  </Button>
                )}
              </Typography>
            </form>
            <Typography align="center">
              Already have a account?{' '}
              <Link onClick={handleSignIn} style={{ color: '#34918c99' }}>
                {' '}
                Signin
              </Link>
            </Typography>
          </DialogContent>
        ) : forgotPasswordState.changeForm2 && !signState.changeForm ? (
          <DialogContent>
            <p
              style={{
                color: 'red',
                fontSize: '16px',
                paddingLeft: '20px',
                paddingRight: '20px'
              }}
            >
              {messageFromServer}
            </p>
            <form
              style={{
                padding: '60px',
                paddingTop: '50px',
                paddingBottom: '50px',
                margin: 'auto'
              }}
              onSubmit={handleForgetPasswordSubmit}
            >
              <TextField
                id="userName"
                label="Your email"
                type="email"
                name="userName"
                fullWidth
                onChange={handleForgetPasswordChange}
                required
              />
              <br></br>
              <br></br>
              <Typography align="center">
                <Button
                  className="btnAdd"
                  style={{
                    width: '160px', color: 'white',
                    background: 'rgb(1, 160, 90)'
                  }}
                  onClick={handleForgetPasswordSubmit}
                >
                  Reset password
                </Button>
              </Typography>
            </form>
            <Typography
              align="center"
              style={{ paddingBottom: '10px', marginBottom: '10px' }}
            >
              <Link
                onClick={handleSignIn}
                style={{
                  paddingBottom: '20px',
                  color: '#34918c99',
                  textDecoration: 'none',
                  marginBottom: '10px'
                }}
              >
                Remember your password?
              </Link>
            </Typography>
            <Typography align="center">
              Don't have a account?
              <Link
                onClick={handleSignUp}
                style={{
                  textDecoration: 'none',
                  color: '#34918c99',
                  paddingLeft: '6px'
                }}
              >
                Signup
              </Link>
            </Typography>
          </DialogContent>
        ) : (
          <DialogContent>
            <p
              style={{
                color: 'red',
                fontSize: '16px',
                paddingLeft: '20px',
                paddingRight: '20px'
              }}
            >
              {success_message.general !== undefined
                ? success_message.general
                : ''}
              {error_message.error !== undefined ? error_message.error : ''}
            </p>
            <form
              style={{ padding: '60px', margin: 'auto' }}
              onSubmit={handleSignUpSubmit}
            >
              <TextField
                id="name"
                label="Name"
                name="name"
                fullWidth
                onChange={handleSignUpChange}
                required
              />
              <br></br>
              <br></br>
              <TextField
                id="email"
                type="email"
                label="Email"
                name="email"
                fullWidth
                onChange={handleSignUpChange}
                required
              />
              <br></br>
              <br></br>
              <TextField
                id="password"
                label="Password"
                type="password"
                name="password"
                fullWidth
                onChange={handleSignUpChange}
                required
              />
              <br></br>
              <br></br>
              <br></br>
              <Typography align="center">
                {!verState.isVerified ? (
                  <>
                    <Button className="btnAdd" onClick={sendMail} style={{
                      color: 'white',
                      background: 'rgb(1, 160, 90)'
                    }}>
                      Send verification Email
                    </Button>

                    <TextField
                      id="code"
                      label="Enter verification code"
                      name="code"
                      fullWidth
                      onChange={handleCodeChange}
                      required
                    />
                    <Button className="btnAdd" onClick={checkCode} style={{
                      color: 'white',
                      background: 'rgb(1, 160, 90)'
                    }}>
                      Verify account
                    </Button>
                  </>
                ) : (
                  <Button
                    className="btnAdd"
                    style={{
                      width: '90px', textDecoration: 'none', color: 'white',
                      background: 'rgb(1, 160, 90)'
                    }}
                    type="submit"
                  >
                    Signup
                  </Button>
                )}
              </Typography>
            </form>
            <Typography align="center">
              Already have an account?{' '}
              <Link
                onClick={handleSignIn}
                style={{
                  textDecoration: 'none',
                  color: '#34918c99',
                  paddingLeft: '6px'
                }}
              >
                {' '}
                Signin
              </Link>
            </Typography>
          </DialogContent>
        )}

        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            style={{ color: '#00918c' }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

  function HorizonatalA11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
      style: {
        justifyContent: 'center'
      }
    };
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.user.auth,
    common_loader: state.ui.common_loader,
    error: state.user.error_message,
    msg: state.user.success_message,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginUser: (creds) => dispatch(loginUser(creds)),
    loginUserOTP: (creds) => dispatch(loginUserOTP(creds)),
    loginUserOTPReceived: (creds) => dispatch(loginUserOTPReceived(creds)),
    verifyOptCode: (creds) => dispatch(verifyOptCode(creds)),
    resendOptCode: (creds) => dispatch(resendOptCode(creds)),
    signup: (creds) => dispatch(signup(creds)),
    forgetPassword: (creds) => dispatch(forgetPassword(creds)),
    getCartItems: () => dispatch(getCartItems()),
    addToCart: (product) => dispatch(addToCart(product)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignDialog)
);
